"use client";

import { useAuthUrl } from "../../lib/hooks/useAuthurl";
import Button from "./Button";

export default function SignIn({
  buttonText,
  ...buttonProps
}: {
  buttonText?: string;
}) {
  const signInUrl = useAuthUrl("/sign-in");

  if (!signInUrl) {
    return null;
  }

  return (
    <Button href={signInUrl} {...buttonProps}>
      {buttonText || "Sign in"}
    </Button>
  );
}
